/* eslint-disable */
import React from 'react'
import { Map as LeafletMap, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import Search from "./Search";

class Map extends React.Component {
  render() {

    return (
      <div>
        { this.props.mylat ? (
            <LeafletMap
                center={[this.props.mylat, this.props.mylng]}
                zoom={10}
                maxZoom={19}
                attributionControl={true}
                zoomControl={true}
                doubleClickZoom={true}
                scrollWheelZoom={true}
                dragging={true}
                attributionControl={false}
                attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                animate={true}
                easeLinearity={0.35}
              >
                <TileLayer
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                />
                <Search
                  link={this.props.link} />
              </LeafletMap>

              
          ) : (
            <LeafletMap
               center={[45.4036979, 10.9969362]}
                zoom={10}
                maxZoom={19}
                attributionControl={false}
                attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                zoomControl={true}
                doubleClickZoom={true}
                scrollWheelZoom={true}
                dragging={true}
                animate={true}
                easeLinearity={0.35}
              >
                <TileLayer
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                />
                <Search
                  link={this.props.link} />
              </LeafletMap>
          )}
          </div>
    );
  }
}

export default Map